const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
    tags: [],
    search: "",
    author: "",
};

const filterSlice = createSlice({
    name: "video",
    initialState,
    reducers: {
        tagSelected: (state, action) => {
            state.tags.push(action.payload);
        },
        tagRemoved: (state, action) => {
            const indexToRemove = state.tags.indexOf(action.payload);

            if (indexToRemove !== -1) {
                state.tags.splice(indexToRemove, 1);
            }
        },
        authorSelected: (state, action) => {
            state.search = "";
            state.tags = [];
            state.author = action.payload;
        },
        searched: (state, action) => {
            state.search = action.payload;
        },
        clearFilter: (state) => {
            state.search = "";
            state.tags = [];
            state.author = "";
        }
    },
});

export default filterSlice.reducer;
export const { tagSelected, tagRemoved, authorSelected, searched, clearFilter } = filterSlice.actions;
